/**
 * hBuffer can be used when you want to group multiple calls to a single async call based on given ids
 * a small delay is used to do the trick, default is 10 ms
 * if you call hBuffer instance .register method multiple times the hBuffer will call your doAsync callback only once with an array of ids (grouped)
 * you can pass a callback to filter ids, for example to check if it exists in cache
 * you can pass a callback to process result before it resolve the promises, for example to add the result to the cache
 *
 * @params: $q: if you don't pass it, it will use $q from window, pass it to avoid the need to run $digest after each call
 */
window.hBuffer = function (_q) {

    var self = this;
    var _delay = 10; // ms
    var $q = _q || window.$q;

    var pending = [];
    var inProgress = [];
    var ready = [];
    var waiters = {};

    var isWaiting;
    var idsSplitter = "|";

    var _filterIdsCB = function (ids) {
        return ids;
    };

    var _doAsync;

    var _processResultCB = function (result) {
        return result;
    };

    var removeFromInProgress = function (id) {
        var index = inProgress.indexOf(id);

        if (id > -1) {
            inProgress.splice(index, 1);
        } else {
            console.warn("Trying to remove:", id, "from inProgress, but not found");
        }
    };

    var start = function () {
        if (!isWaiting && pending.length) {
            setTimeout(function () {
                isWaiting = false;
                inProgress = inProgress.concat(pending);
                var requesting = angular.copy(pending);
                pending = [];

                var _result;

                _doAsync(inProgress)
                    .then(function (result) {
                        _result = _processResultCB(result);
                    })
                    .finally(function () {
                        ready = ready.concat(requesting);

                        for (var i in requesting) {
                            removeFromInProgress(requesting[i]);
                        }

                        for (var joinIds in waiters) {
                            var ids = joinIds.split(idsSplitter).map(parseInt);
                            var allFound = true;

                            for (var i in ids) {
                                if (ready.indexOf(ids[i]) === -1) {
                                    allFound = false;
                                    break;
                                }
                            }

                            if (allFound) {
                                var defers = waiters[joinIds].defers;

                                for (var i = 0; i < defers.length; i++) {
                                    defers[i].resolve((i === 0)? _result: angular.copy(_result));
                                }

                                waiters[joinIds].defers = [];
                            }
                        }
                    });
            }, _delay);

            isWaiting = true;
        }
    };

    self.filterIds = function (filterIdsCB) {
        _filterIdsCB = filterIdsCB;
        return self;
    };

    self.processResult = function (processResultCB) {
        _processResultCB = processResultCB;
        return self;
    };

    self.doAsync = function (doAsync) {
        _doAsync = doAsync;
        return self;
    };

    self.setDelay = function (delay) {
        _delay = delay;
    };

    self.register = function (ids) {
        var defer = $q.defer();

        if (!Array.isArray(ids)) {
            ids = [ids];
        }

        ids = _filterIdsCB(ids);

        if (ids.length === 0) {
            defer.resolve();
        }
        else {

            for (var i in ids) {
                if (inProgress.indexOf(ids[i]) === -1) {
                    if (pending.indexOf(ids[i]) === -1) {
                        pending.push(ids[i]);
                    }
                }
            }

            var requestIdentifier = ids.join("idsSplitter");
            waiters[requestIdentifier] = waiters[requestIdentifier] || {defers: []};
            waiters[requestIdentifier].defers.push(defer);

            start();
        }

        return defer.promise;
    }
};